import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

const useStyles = makeStyles(theme => ({
  avatar: {
    width: 60,
    height: 60,
  },
  card: {
    backgroundColor: theme.palette.primary.main,
  },
  text: {
    color: theme.palette.primary.contrastText,
  },
}));

const ProfileCard = ({ name, text, subtext, imgUrl }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent>
        <Grid container spacing={1}>
          <Grid item>
            <Avatar className={classes.avatar} src={imgUrl} />
          </Grid>
          <Grid item>
            <Typography className={classes.text} variant="h6" component="h2">
              {name}
            </Typography>
            <Typography
              className={classes.text}
              variant="body2"
              color="textSecondary"
              component="p"
            >
              {text}
              <br />
              {subtext}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

ProfileCard.propTypes = {
  name: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  subtext: PropTypes.string.isRequired,
  imgUrl: PropTypes.string.isRequired,
};

export default ProfileCard;
